import { pageDto } from "../pagedto";
import { PaginationFeaturesDto } from "../paginationfeaturesdto";
import { RateModelDto } from "../ratemodeldto";
import { GeneralDiscountCatalogDto } from "./GeneralDiscountCatalogDto.model";

export class DiscountRateModelCatalogDto {
    discountRateModelCatalogPkDto?: {
        rateModelId?: number,
        generalDiscountCatalogId: number
    };
    studentIndicator?: string;
    managerIndicator?: string;
    usesControlType?: string;;
    cumulativeIndicator?:string
    generalDiscountCatalogDto?: GeneralDiscountCatalogDto;
    rateModelDto?: RateModelDto;

    constructor(data?: Partial<DiscountRateModelCatalogDto>) {
        Object.assign(this, data);
    }
}

export class DiscountRateModelCatalogResponse {
    discountRateModelCatalogDto: DiscountRateModelCatalogDto[] = [];
    pageDto: pageDto = new pageDto({});
}

export class DiscountRateModelCatalogRequest {
    discountControlTypesDto: DiscountRateModelCatalogDto = new DiscountRateModelCatalogDto();
    pageRequest: PaginationFeaturesDto = new PaginationFeaturesDto({});
}







